import React, { ReactElement } from 'react';
import { View, ViewStyle } from 'react-native';

import { useScreenContext } from '../../contexts/ScreenContext';
import Colors from '../../theming/Colors';
import Spacing from '../../theming/Spacing';
import { SpacingType } from '../../theming/SpacingType';
import KitIcon from '../KitIcon';
import KitText from '../KitText';
import KitTouchable from '../KitTouchable';
import { defaultStyles } from './styles';

export interface KitFrameProps {
  title?: string;
  enableChevron?: boolean;
  onPress?: () => void;
  children?: React.ReactNode;
  containerStyle?: ViewStyle;

  /** When undefined, defaults are applied based on display width. */
  horizontalSpacing?: SpacingType;
}

const KitFrame = ({
  title,
  containerStyle,
  enableChevron,
  onPress,
  children,
  horizontalSpacing,
}: KitFrameProps): ReactElement => {
  const { edgeSpacing } = useScreenContext({
    fixedSpacingType: horizontalSpacing,
  });

  return (
    <View
      style={[
        defaultStyles.container,
        containerStyle,
        { marginHorizontal: edgeSpacing },
      ]}
    >
      {title || enableChevron ? (
        <View
          style={{
            marginHorizontal: Spacing.l,
            marginTop: Spacing.l,
            marginBottom: Spacing.xs,
          }}
        >
          {onPress ? (
            <KitTouchable onPress={onPress}>
              <View
                style={{
                  flex: 1,
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                {title ? (
                  <KitText bold color={Colors.N900} fontSize={14}>
                    {title}
                  </KitText>
                ) : null}
                {enableChevron ? (
                  <View>
                    <KitIcon name='arrow-right' size={16} />
                  </View>
                ) : null}
              </View>
            </KitTouchable>
          ) : (
            <View>
              {title ? (
                <KitText bold color={Colors.N900} fontSize={14}>
                  {title}
                </KitText>
              ) : null}
            </View>
          )}
        </View>
      ) : null}
      {children}
    </View>
  );
};

export default KitFrame;
